import type { DependencyContainer } from 'tsyringe';
import { IClassificationAssistEngineToken } from './ClassificationAssistEngine';
import { BffClassificationAssistEngine } from './BffClassificationAssistEngine';

/**
 * Binds the classification assist engine to the BFF-backed implementation. Swap
 * the bound class to retarget the assist without touching the view model.
 */
export function registerClassificationAssistEngine(container: DependencyContainer): void {
    container.register(IClassificationAssistEngineToken, { useClass: BffClassificationAssistEngine });
}
